<li [ngClass]="{'edit-menu-item-active':isSelectedAxis}" class="list-group-item edit-menu-item">
  <div class="row">
    <div class="col" (click)="onAxisSettingsStartEdit()">
      <div class="edit-menu-item-icon">
        <i class="fa-solid fa-up-down"></i>
      </div>
      <span [innerHTML]="axisSettings.axisYLabel"></span>
      @if (isAxisMisconfigured) {
        <span class="text-danger ml-1"><i class="fa-solid fa-circle-exclamation"></i></span>
      }
      @if (hasDeletedSignals) {
        <span class="text-danger ml-1"><em class="fa-solid fa-circle-exclamation"></em></span>
      }
    </div>
    <div class="col-auto">
      <div class="edit-menu-item-functions">
        <div class="d-inline-flex" ngbDropdown>
          <button class="btn btn-xs btn-outline-secondary dropdown-no-arrow" id="dropdownBasic1"
            ngbDropdownToggle>
            <span class="fa-solid fa-ellipsis-vertical"></span>
          </button>
          <div ngbDropdownMenu>
            <button (click)="onAxisSettingsStartEdit()" ngbDropdownItem>
              <span class="fa-solid fa-pen"></span>
              <span [innerHTML]="'Edit axis'| translate"></span>
            </button>
            <button (click)="onRemoveAxis(axisSettings)" class="text-danger" ngbDropdownItem>
              <span class="fa-solid fa-trash"></span>
              <span [innerHTML]="'Delete axis'|translate"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <scitis-line-widget-axis-edit
    (axisSettingsChanged)="onAxisSettingsChanged($event)"
    (hasDeletedSignalsChanged)="onHasDeletedSignalsChanged($event)"
    [isSelectedAxis]="isSelectedAxis ?? false"
    [usableSignals]="usableSignals"
    [axisSettings]="axisSettings"
    [usedSignalIds]="usedSignalIds">

  </scitis-line-widget-axis-edit>
</li>
